export const toSearchableString = (str: string) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
};

export const toHumanReadableAmount = (amount: number): string => {
  return Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
};

export const normalizeQuotes = (text: string): string => {
  return text.replace(/[""«»„"]/g, '"').replace(/['']/g, "'");
};

/** The digits of `value` alone, every other character dropped — a SIREN or SIRET to copy or link. */
export const digitsOnly = (value: string): string => value.replace(/\D/g, "");
